// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  getNotificationListStatus: { data: null },
  createNotificationStatus: { data: null },
  editNotificationStatus: { data: null },
  sendAgainNotificationStatus: { data: null },
  deleteNotificationStatus: { data: null },
};
